const AndroidRegex = /Android(?:\s+([.0-9]+))?/;
const ChromeRegex = /(Chrome|CriOS)\/([.0-9]+)/i;
const WebkitRegex = /AppleWebKit\/([.0-9]+)/i;
const FanpageNativeAppRegex = /it\.(fanpage|cookist|cookist_it|cookist_com|kodami|geopop|ohga|wamily_it|lexplain_it)\.rn\.(android|ios)\/([0-9.]+)/i;
//https://docs.microsoft.com/en-us/microsoft-edge/web-platform/user-agent-guidance
const EdgeDetect = /Edg(A|iOS)?\//i;
//https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/User-Agent/Firefox
const FirefoxDetect = /(Firefox|FxiOS)\//i;
const FirefoxInternals = /Mozilla\/(?:[0-9.]+) \(([^;]+);\s*([^;)]+)(?:;\s*([^)]+))?\)/i;
const MobileMatch = /mobile/i;
const WebviewVersion = /Version\/([.0-9]+)/;
const OtherStockBrowsers = /(SamsungBrowser|MiuiBrowser)/i;
const WVFlag = /;\s*wv\s*[;)]/;
const Safari = /(safari|iphone|ipad)/i;
const FB = /(FBAV|FBAN|FBIOS|FB_IAB)/i;
const Twitter = /Twitter/i;
const Instagram = /Instagram/i;
function getSafariVersion(ua) {
    const vers = getVersionField(ua);
    if (vers) {
        const split = vers.split(".", 2);
        const major = split && split.length > 0 ? parseInt(split[0]) : 0;
        const minor = split && split.length > 1 ? parseInt(split[1]) : 0;
        return {
            major: !isNaN(major) ? major : 0,
            minor: !isNaN(minor) ? minor : 0,
            full: vers
        };
    }
    else {
        return null;
    }
}
function getVersionField(ua) {
    const matches = ua.match(WebviewVersion);
    if (matches) {
        return matches[1];
    }
    else {
        return null;
    }
}
function matchInternals(ua) {
    const internals = ua.match(FirefoxInternals);
    const device = {};
    const platform = {};
    const extra = {};
    let webview = false;
    if (internals && internals.length >= 2) {
        if (internals[1].match(/android/i)) {
            platform.android = true;
            if (internals.length >= 3 && internals[2].match(/tablet/i)) {
                device.tablet = true;
            }
            else
                device.phone = true;
        }
        else if (internals[1].match(/iphone/i)) {
            device.phone = true;
            platform.ios = true;
            extra.safariVersion = getSafariVersion(ua);
        }
        else if (internals[1].match(/ipad/i)) {
            device.tablet = true;
            platform.ios = true;
            extra.safariVersion = getSafariVersion(ua);
        }
        else if (internals[1].match(/macintosh/i)) {
            if (internals.length >= 4) {
                platform.macosx = true;
                device.other = true;
            }
            else {
                platform.ios = true;
                device.tablet = true;
            }
            extra.safariVersion = getSafariVersion(ua);
        }
        else if (internals[1].match(/x11/i)) {
            platform.linux = true;
            device.other = true;
        }
        else if (internals[1].match(/linux/i)) {
            if (internals.length >= 3 && internals[2].match(/android/i)) {
                device.phone = true;
                platform.android = true;
                webview = true;
            }
        }
        else if (internals[1].match(/windows/i)) {
            device.other = true;
            platform.windows = true;
        }
        else {
            platform.other = true;
            device.other = true;
        }
    }
    else {
        platform.other = true;
        device.other = true;
    }
    const androidMatch = ua.match(AndroidRegex);
    if (androidMatch && androidMatch.length >= 1) {
        const androidVersion = androidMatch[1] ? androidMatch[1] : "1.0.0";
        const webkitMatches = ua.match(WebkitRegex);
        if (androidVersion) {
            extra.androidVersion = androidVersion;
        }
        if (webkitMatches && webkitMatches.length > 0) {
            extra.webkitVersion = webkitMatches[1];
        }
    }
    const retObj = {
        platform: platform,
        device: device,
        webview: webview
    };
    if (extra && (extra.androidVersion || extra.webkitVersion || extra.safariVersion)) {
        retObj.extra = extra;
    }
    return retObj;
}
/**
 *
 * @note adv purposes`
 * @author Giovanni Citro (shatsu)
 * @author Lorenzo Muscariello (lwbu)
 * @param window
 * @returns contestoBrowser:string
 */
export function getContestoBrowser(window) {
    let contestoBrowser = 'browser';
    const { browser, extra } = detectWebView(window.navigator.userAgent);
    if (browser.native_app)
        contestoBrowser = browser.chrome ? 'native_android' : 'native_ios';
    else if (extra && extra.isFacebook)
        contestoBrowser = 'fb_webview';
    else if (extra && extra.isInstagram)
        contestoBrowser = 'ig_webview';
    console.log(`[ADS UTILS] contesto browser = ${contestoBrowser}`);
    return contestoBrowser;
}
/**
 *
 * @note Porting di `WebViewDetect.detect`
 * @author Riccardo Di Dato (shatsu)
 * @author Lorenzo Muscariello (lwbu)
 * @param ua_string
 * @returns
 */
export function detectWebView(ua_string = null) {
    const ua = ua_string ? ua_string : window.navigator.userAgent;
    const nativeAppMatch = ua.match(FanpageNativeAppRegex);
    const edgeMatch = ua.match(EdgeDetect);
    const firefoxMatch = ua.match(FirefoxDetect);
    const chromeMatches = ua.match(ChromeRegex);
    const safariMatches = ua.match(Safari);
    const mobileMatching = ua.match(MobileMatch);
    if (nativeAppMatch && nativeAppMatch.length > 3) {
        const product = nativeAppMatch[1];
        const sop = nativeAppMatch[2];
        const ver = nativeAppMatch[3];
        const platObj = sop == "android" ? { android: true } : { ios: true };
        const brObj = { webview: true, native_app: true };
        if (sop == "android") {
            brObj.chrome = true;
        }
        else {
            brObj.safari = true;
        }
        return {
            platform: platObj,
            browser: brObj,
            device: null,
            native_app: true,
            extra: {
                product: product,
                nativeAppVersion: ver
            }
        };
    }
    else if (edgeMatch && edgeMatch.length >= 1) {
        const browser = {
            edge: true
        };
        const device = {};
        let platform = {};
        if (edgeMatch.length >= 2 && edgeMatch[1]) {
            device.phone = true;
            if (edgeMatch[1].toLowerCase() == "a")
                platform.android = true;
            else if (edgeMatch[1].toLowerCase() == "ios")
                platform.ios = true;
            else
                platform.other = true;
        }
        else {
            const internalData = matchInternals(ua);
            platform = internalData.platform;
            device.other = true;
        }
        return {
            browser: browser,
            device: device,
            platform: platform
        };
    }
    else if (firefoxMatch && firefoxMatch.length >= 1) {
        const browser = {
            firefox: true
        };
        const internalData = matchInternals(ua);
        if (internalData.webview)
            browser.webview = true;
        return {
            device: internalData.device,
            browser: browser,
            platform: internalData.platform
        };
    }
    else if (chromeMatches && chromeMatches.length > 1) {
        const internalDetect = matchInternals(ua);
        let splitVersion = null;
        if (internalDetect.platform.android &&
            internalDetect.extra &&
            internalDetect.extra.androidVersion) {
            // ?TODO: Verificare, questa variabile non viene mai usata!!!
            splitVersion = internalDetect.extra.androidVersion.split(".").map((e) => parseInt(e));
        }
        if (!internalDetect.extra)
            internalDetect.extra = {};
        internalDetect.extra.chromeVersion = chromeMatches[1];
        const browser = {
            chrome: true
        };
        let webview = false;
        if (internalDetect.platform.android) {
            if (mobileMatching)
                internalDetect.device = { phone: true };
            else
                internalDetect.device = { tablet: true };
        }
        const webviewMatches = ua.match(WebviewVersion);
        if (webviewMatches) {
            webview = true;
        }
        else if (ua.match(OtherStockBrowsers)) {
            delete browser["chrome"];
            browser.stock = true;
        }
        const fb = ua.match(FB);
        const tw = ua.match(Twitter);
        const ig = ua.match(Instagram);
        if (!webview && (ua.match(WVFlag) || fb || tw || ig)) {
            webview = true;
        }
        if (webview)
            browser.webview = webview;
        if (fb)
            internalDetect.extra.isFacebook = true;
        else if (tw)
            internalDetect.extra.isTwitter = true;
        else if (ig)
            internalDetect.extra.isInstagram = true;
        return {
            browser: browser,
            ...internalDetect
        };
    }
    else if (ua.match(WebviewVersion) && ua.match(AndroidRegex)) {
        const internalDetect = matchInternals(ua);
        if (!internalDetect.device.tablet &&
            !internalDetect.device.other)
            internalDetect.device = { phone: true };
        internalDetect.platform = { android: true };
        return {
            browser: {
                stock: true,
                webview: true
            },
            ...internalDetect
        };
    }
    else if (safariMatches) {
        const webview = window && window['navigator'] && window.navigator['standalone'] ? true : false;
        const isFacebook = ua.match(FB);
        const isInstagram = ua.match(Instagram);
        const internalDetect = matchInternals(ua);
        const browser = {
            safari: true
        };
        if (internalDetect.platform.ios && (webview || isFacebook || isInstagram)) {
            browser.webview = true;
            if (isFacebook)
                internalDetect.extra = {
                    isFacebook: true
                };
            else if (isInstagram)
                internalDetect.extra = {
                    isInstagram: true
                };
        }
        return {
            browser,
            ...internalDetect
        };
    }
    else {
        return { platform: { other: true }, browser: { other: true }, device: { other: true } };
    }
}
